import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { TPopProgram } from '~shared/api/programs-popular/types'
import { Hit } from '~shared/icons/hit'
import { programLink } from '~shared/utils/program-link'

type Props = {
  popularProgram: TPopProgram
}

export const PopularProgramCard: React.FC<Props> = ({ popularProgram }) => {
  const formats = [
    {
      price: popularProgram?.costOnline?.priceOnline,
      studyDurationYears: popularProgram?.costOnline?.studyDurationYearsOnline,
      studyDurationMonths:
        popularProgram?.costOnline?.studyDurationMonthsOnline,
      studyHours: popularProgram?.costOnline?.studyHoursOnline
    },
    {
      price: popularProgram?.cost?.price,
      studyDurationYears: popularProgram?.cost?.studyDurationYears,
      studyDurationMonths: popularProgram?.cost?.studyDurationMonths,
      studyHours: popularProgram?.cost?.studyHours
    },
    {
      price: popularProgram?.costOffline?.priceOffline,
      studyDurationYears:
        popularProgram?.costOffline?.studyDurationYearsOffline,
      studyDurationMonths:
        popularProgram?.costOffline?.studyDurationMonthsOffline,
      studyHours: popularProgram?.costOffline?.studyHoursOffline
    }
  ].filter(f => f.price !== null && f.price !== undefined)

  const cheapestCost = formats.length
    ? formats.reduce((min, current) =>
        current.price! < min.price! ? current : min
      )
    : null

  return (
    <Link
      prefetch={false}
             href={programLink(popularProgram)}>
      <div className='relative'>
        <Image
          src={popularProgram?.image.url}
          alt={popularProgram?.name ?? 'program image'}
          width={600}
          height={600}
          className='object-cover rounded-[24px] w-full max-h-[250px] md:max-h-none md:aspect-square'
        />
        <div className='p-[16px] absolute top-0 left-0 w-full h-full xl:p-[24px] flex flex-col justify-between z-20'>
          <div className='flex gap-[4px] justify-between items-start  text-[14px] md:text-[16px]'>
            <div className='flex flex-wrap gap-y-[8px]'>
              <div className='bg-white rounded-[24px]  h-fit overflow-hidden'>
                <span
                  className='px-[10px]  py-[6px] flex items-center max-w-[260px]'
                  style={
                    popularProgram?.faculty?.color
                      ? {
                          backgroundColor: `${popularProgram?.faculty?.color}30`,
                          color: popularProgram?.faculty?.color
                        }
                      : {}
                  }>
                  {popularProgram?.faculty?.name}
                </span>
              </div>
              <span className='bg-white px-[10px]  py-[6px] flex items-center rounded-[24px]'>
                {popularProgram?.category?.name}
              </span>
            </div>
            <span className='flex items-center rounded-[24px] gap-[4px] bg-[#FFF741] px-[10px] py-[6px]'>
              <Hit size={13} className='hidden md:inline-block' />
              <Hit size={8} className='md:hidden' />
              хит
            </span>
          </div>
          <div className='text-white'>
            <p className='text-[16px] md:text-[24px] font-medium'>
              {popularProgram?.name}
            </p>
            <p className='text-[14px] mt-[8px] xl:mt-[16px]'>
              {Number(cheapestCost?.studyDurationYears) > 0 && (
                <span>{cheapestCost?.studyDurationYears} год </span>
              )}
              {Number(cheapestCost?.studyDurationYears) > 0 &&
                Number(cheapestCost?.studyDurationMonths) > 0 && (
                  <span>/ </span>
                )}
              {Number(cheapestCost?.studyDurationMonths) > 0 && (
                <span>{cheapestCost?.studyDurationMonths} мес </span>
              )}
              {Number(cheapestCost?.studyHours) > 0 && (
                <span>/ {cheapestCost?.studyHours} часов </span>
              )}
            </p>
          </div>
        </div>
        <div className='absolute top-0 left-0 w-full h-full bg-[#00000040] z-10 rounded-[24px]' />
      </div>
    </Link>
  )
}
